export type FieldElement = HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;

const debounceTimers = new Map<() => void, NodeJS.Timeout>();

/** Note: This will only work if `callback` does not change between calls */
export const debounce = <T extends any[]>(callback: (...args: T) => void, delay = 500, ...args: T) => {
  clearTimeout(debounceTimers.get(callback));
  debounceTimers.set(callback, setTimeout(callback, delay, ...args));
};

export const getFormError = (invalidFields?: NodeListOf<FieldElement>) => {
  const errorMessages: Record<string, string[]> = {};

  invalidFields?.forEach(({ name, validationMessage }) => {
    if (name && validationMessage) {
      errorMessages[validationMessage] ??= [];
      errorMessages[validationMessage].push(name);
    }
  });

  return Object.entries(errorMessages)
    .map(([message, fields]) => `> ${message}: ${fields.join(', ')}`)
    .join('\n');
};
